/* eslint-disable react/prop-types */
import React from 'react';
import { DragOverlay } from '@dnd-kit/core';
import { useConfiguratorStore } from '../store';
import { useDesignStore } from '../store/design/context';

const DraggableOverlay = () => {
  const { choices } = useConfiguratorStore((state) => state.configurator);
  const { selectedProduct } = useDesignStore((state) => state.design);
  return (
    <>
      {selectedProduct && (
        <DragOverlay dropAnimation={null}>
          <img
            className="drag-overlay-img"
            src={choices?.[selectedProduct?.choiceId]?.mediaUrl}
            alt="Placeholder img"
            height="auto"
            width="auto"
            style={{
              scale: 0.5,
              touchAction: 'manipulation',
              WebkitTouchCallout: 'none',
              WebkitUserSelect: 'none',
              msUserSelect: 'none',
              userSelect: 'none'
            }}
          />
        </DragOverlay>
      )}
    </>
  );
};

export default DraggableOverlay;
